import { HttpContext, HttpContextToken } from "@angular/common/http";

function create<T>(token: HttpContextToken<T>, value: T) {
    return new HttpContext().set(token, value);
}

const DisableSpinner = new HttpContextToken<boolean>(() => false);

export const CustomHttpContext = {
    create,
    DisableSpinner
};
